import axios, { AxiosResponse } from "axios"
import { EnviarInvitacionEmpresaGestionadaAsesoriaCommandProps } from "./Commands/EnviarInvitacionEmpresaGestionadaAsesoriaCommand"
import { UpdateInvitacionesAsesoriaCommandProps } from "./Commands/UpdateInvitacionesAsesoriaCommand"
import { GetEmpresasGestionadasAsesoriaByFiltersDtoProps } from "./DTOs/GetEmpresasGestionadasAsesoriaByFiltersDto"
import {
  GetEmpresasGestionadasAsesoriaByFiltersDtoAdapter,
  empresaGestionadaAsesoriaInvitacionAdapter,
} from "./EmpresaGestionadaAsesoria.adapter"
import { GetEmpresasGestionadasAsesoriaByFiltersDtoIPagedEnumerable } from "./Schemas/GetEmpresasGestionadasAsesoriaByFiltersDtoIPagedEnumerable"
import { GetInvitacionesAsesoriaDtoIPagedEnumerableProps } from "./Schemas/GetInvitacionesAsesoriaDtoIPagedEnumerable"
import { EstadoInvitacionAsesoriaType } from "./Types/EstadoInvitacionAsesoria"
import { SortingCriteria } from "./interfaces/SortingCriteria"

export interface GetEmpresasGestionadasAsesoriaByFiltersQueryParamsProps {
  IndustriaIds?: Array<number | undefined>
  EstadoInvitaciones?: Array<EstadoInvitacionAsesoriaType>
  Keyword?: string
  ProvinciaIds?: Array<number | undefined>
  SortingCriteria?: SortingCriteria
  IsEnabled?: boolean
  MaxResultCount?: number
  SkipCount?: number
}
/**
 * Retrieves a list of empresas gestionadas asesoria based on the provided query parameters.
 * @param queryParams - The query parameters used to filter the results.
 * @returns A promise that resolves to a paged enumerable containing the filtered empresas gestionadas asesoria.
 */
export async function GetEmpresasGestionadasAsesoriaByFilters(
  queryParams: GetEmpresasGestionadasAsesoriaByFiltersQueryParamsProps
): Promise<GetEmpresasGestionadasAsesoriaByFiltersDtoIPagedEnumerable> {
  const {
    data,
  }: { data: GetEmpresasGestionadasAsesoriaByFiltersDtoIPagedEnumerable } =
    await axios.get("/EmpresaGestionadaAsesoria", {
      params: queryParams,
    })
  return {
    currentPage: data?.currentPage,
    items: data.items?.map(
      (empresa: GetEmpresasGestionadasAsesoriaByFiltersDtoProps) =>
        GetEmpresasGestionadasAsesoriaByFiltersDtoAdapter(empresa)
    ),
    totalCount: data?.totalCount,
  }
}

export async function postEnviarInvitacionGestionadaAsesoria(
  invitaciones: EnviarInvitacionEmpresaGestionadaAsesoriaCommandProps
) {
  return axios.post(
    "/EmpresaGestionadaAsesoria/enviar-invitacion",
    invitaciones
  )
}

/**
 * Deletes an EmpresaGestionadaAsesoria by its ID.
 * @param id The ID of the EmpresaGestionadaAsesoria to delete.
 * @returns A Promise that resolves to the AxiosResponse object.
 */
export async function deleteEmpresaGestionadaAsesoriaById(
  id: string
): Promise<AxiosResponse> {
  const response = await axios.delete(`/EmpresaGestionadaAsesoria/${id}`)
  return response
}

export async function getEmpresaGestionadaAsesoriaInvitacion(): Promise<GetInvitacionesAsesoriaDtoIPagedEnumerableProps> {
  const {
    data,
  }: Record<"data", GetInvitacionesAsesoriaDtoIPagedEnumerableProps> =
    await axios.get("/EmpresaGestionadaAsesoria/invitaciones")
  return {
    currentPage: data.currentPage,
    items: data.items?.map((invitacion) =>
      empresaGestionadaAsesoriaInvitacionAdapter(invitacion)
    ),
    totalCount: data.totalCount,
  }
}

export async function putEmpresaGestionadaAsesoriaEstadoInvitacion(
  queryParams: UpdateInvitacionesAsesoriaCommandProps
) {
  await axios.put("/EmpresaGestionadaAsesoria/invitaciones", queryParams)
}
